// Footer.js
import React from 'react';

function Footer() {
  return (
    <div className="footer-message" style={{
        position: 'fixed',   // Absolute position
        bottom: 0,              // Stick to the bottom
        left: 0,                // Align to the left side
        right: 0,               // and right side, spanning the full width
        backgroundColor: "#000000",
        color: "#ffffff",
        textAlign: "center",
        padding: "3px 0",
        fontSize: "12px"
    }}>
      <p style={{ margin: "0" }}>
        <a href="https://www.iem.fraunhofer.de/de/datenschutzerklaerung.html"
           rel="nofollow noreferrer noopener"
           target="_blank"
           style={{ color: "#ffffff", textDecoration: "none" }}>
           Datenschutz
        </a>
	 &nbsp; 
	<a href="https://www.fraunhofer.de/de/impressum.html"
           rel="nofollow noreferrer noopener"
           target="_blank"
           style={{ color: "#ffffff", textDecoration: "none" }}>
           Impressum
        </a>
      </p>
    </div>
  );
}

export default Footer;
